exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.category-column[data-v-08cb6132] {\n    max-width: 5%;\n}\n", ""]);
